/**
 * Columns definition for the Round By Round votes table
 *
 * @param isPredictor
 * @returns {Array} Columns list
 */
export const composeColumnData = (isPredictor) => {
    let columns = [
        {
            Header: 'Rd',
            accessor: 'roundNumber'
        },
        {
            Header: 'Opponent',
            accessor: 'opponent'
        },
        {
            Header: isPredictor ? 'Predicted Votes' : 'Predicted',
            accessor: 'predictedPoints'
        },
        ...(isPredictor
            ? []
            : [
                  {
                      Header: 'Votes',
                      accessor: 'votes'
                  }
              ])
    ];

    return columns;
};
